const data = [
    { name: "LINKEDIN WALAXY", id: 1 },
    { name: "COOPTATION", id: 2 },
    { name: "ANNONCE (LKD,…)", id: 3 },
    { name: "EMAILING", id: 4 },
    { name: "PHONING", id: 5 },
    { name: "LINKEDIN LITE", id: 6 },
    { name: "RELATIONS ECOLES", id: 8 },
    { name: "CVTHEQUE", id: 9 },
    { name: "PEOPLEFINE", id: 10 },
    { name: "AUTRE", id: 11 },
    { name: "SHERLOCK", id: 12 },
]

export const sources = data.sort((a, b) => a.name.localeCompare(b.name));
